module.exports = __webpack_public_path__ + "media/images/front/marker-02-16e3cb051f8555564cd08ff0da1238a1.png";